<div id="container">
  @if (showHeaderFooter) {
  <app-clarivate-header></app-clarivate-header>
  }
  <div id="content">
    <router-outlet></router-outlet>
  </div>

  @if (showHeaderFooter) {
  <div id="footer">
    <footer cdx-footer>
      <a
        id="manageCookiesLink"
        (click)="openOneTrustModal()"
        (keydown.enter)="openOneTrustModal()"
        cdx-footer-link
        tabindex="0"
        i18n="@@FooterManageCookiePreferences"
        >Manage cookie preferences
      </a>
      <a
        id="contactUsLink"
        [href]="contactUsLink"
        cdx-footer-link
        tabindex="1"
        target="_blank"
        rel="noopener noreferrer"
        i18n="@@FooterContactUs"
        >Contact us
      </a>
    </footer>
  </div>
  }
</div>
